
/*
 * PAWS & PEARLS — THE MUSE SECRET SKY — PHASE 1.4
 * Confirmed Shopify scrolling container correction, 26 October 2026.
 * Install ONLY in the unpublished MAGICAL MUSE WORLD duplicate theme.
 * Replace the existing assets/pp-muse-secret-sky-v1.js contents.
 * Leave A/B in theme.liquid, V18 flight, companion balloons, music and pearls untouched.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var phase = 'shell-v1.5-mobile-window-scroll-test';
  var wrapper = null;
  var sky = null;
  var header = null;
  var started = 0;
  var initialTarget = null;
  var timer = null;
  var observer = null;
  var finished = false;
  var visitorMoved = false;
  var originalScrollBehavior = '';
  var originalScrollPriority = '';
  var scrollStyleNode = null;
  var MAX_WATCH_MS = 9000;
  var stopAt = null;

  function ready() {
    root.classList.remove('pp-muse-sky-preparing');
    root.classList.add('pp-muse-sky-ready');
  }

  function mobileDocumentScroll() {
    // The theme's base.css makes .page-wrapper the scrolling container
    // at >=990px only. At narrower widths Safari scrolls the document.
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function currentScroll() {
    return mobileDocumentScroll() ? window.scrollY : wrapper.scrollTop;
  }

  function setCurrentScroll(y) {
    if (mobileDocumentScroll()) window.scrollTo(0, y);
    else wrapper.scrollTop = y;
  }

  function menuTarget() {
    if (!wrapper || !sky) return null;

    // Use the bottom of the actual sky, not the header wrapper.
    // The live Shopify theme reports header top=0 even when the sky
    // is visibly above the menu. Header-based calculations
    // therefore incorrectly target 0.
    //
    // This is the scroll target independently confirmed
    // by Madam's successful manual test.

    // On Shopify mobile the document scrolls, not .page-wrapper.
    // The sky is before the header, so its bottom is the menu's top.
    if (mobileDocumentScroll()) {
      return Math.max(0, Math.round(window.scrollY + sky.getBoundingClientRect().bottom));
    }
    return Math.max(0, Math.round(
      wrapper.scrollTop +
      sky.getBoundingClientRect().bottom -
      wrapper.getBoundingClientRect().top
    ));
  }

  function finish() {
    if (finished) return;

    finished = true;

    if (timer !== null) {
      window.clearInterval(timer);
    }

    if (stopAt !== null) {
      window.clearTimeout(stopAt);
    }

    if (observer) {
      observer.disconnect();
    }

    if (scrollStyleNode) {
      scrollStyleNode.style.removeProperty('scroll-behavior');

      if (originalScrollBehavior) {
        scrollStyleNode.style.setProperty(
          'scroll-behavior',
          originalScrollBehavior,
          originalScrollPriority
        );
      }
    }

    ready();
  }

  function visitorInteracted() {
    visitorMoved = true;
    finish();
  }

  function align() {
    if (
      finished ||
      visitorMoved ||
      !wrapper ||
      !header ||
      !sky ||
      !wrapper.isConnected ||
      !header.isConnected ||
      !sky.isConnected
    ) {
      return;
    }

    var target = menuTarget();

    if (target === null) return;

    initialTarget = target;

    // IMPORTANT:
    // Scroll Shopify's actual page container,
    // NOT the browser window.

    if (Math.abs(currentScroll() - target) > 2) {
      setCurrentScroll(target);
    }

    // IMPORTANT:
    // Confirm the actual scroll position.
    // Do NOT use the header bounding rectangle,
    // which reported an incorrect position in Shopify.

    if (Math.abs(currentScroll() - target) < 4) {
      ready();
    }
  }

  function geometry() {
    if (
      !sky ||
      !header ||
      !wrapper ||
      !sky.isConnected
    ) {
      return null;
    }

    var wrapperTop =
      wrapper.getBoundingClientRect().top;

    return {
      skyTop: Math.round(
        (mobileDocumentScroll() ? window.scrollY : wrapper.scrollTop) +
        sky.getBoundingClientRect().top -
        (mobileDocumentScroll() ? 0 : wrapperTop)
      ),

      skyBottom: Math.round(
        (mobileDocumentScroll() ? window.scrollY : wrapper.scrollTop) +
        sky.getBoundingClientRect().bottom -
        (mobileDocumentScroll() ? 0 : wrapperTop)
      ),

      headerTop: menuTarget(),

      headerViewportTop: Math.round(
        header.getBoundingClientRect().top
      ),

      skyViewportTop: Math.round(
        sky.getBoundingClientRect().top
      ),

      height: Math.round(
        sky.getBoundingClientRect().height
      ),

      currentScrollY: Math.round(currentScroll()),

      scrollContainer: mobileDocumentScroll() ? 'document' : '.page-wrapper',

      stagePresent: !!document.getElementById(
        'pp-muse-balloon-stage'
      )
    };
  }

  function begin() {
    wrapper = document.querySelector('.page-wrapper');
    sky = document.getElementById('pp-muse-secret-sky');
    header = document.getElementById('header-group');

    if (
      !wrapper ||
      !sky ||
      !header ||
      !wrapper.contains(sky) ||
      !wrapper.contains(header)
    ) {
      ready();

      console.warn(
        '[P&P Secret Sky] Expected scroll container ' +
        'or scene is missing; alignment skipped.'
      );

      return;
    }

    // Respect explicit links to anchors within the page.

    if (window.location.hash) {
      ready();
      return;
    }

    started = Date.now();

    scrollStyleNode = mobileDocumentScroll() ? document.documentElement : wrapper;
    originalScrollBehavior =
      scrollStyleNode.style.getPropertyValue('scroll-behavior');

    originalScrollPriority =
      scrollStyleNode.style.getPropertyPriority('scroll-behavior');

    scrollStyleNode.style.setProperty(
      'scroll-behavior',
      'auto',
      'important'
    );

    // Let visitors take control as soon as they interact.
    // They must be able to scroll UP to discover the sky.

    [
      'wheel',
      'touchstart',
      'pointerdown',
      'keydown'
    ].forEach(function (eventName) {
      window.addEventListener(
        eventName,
        visitorInteracted,
        {
          once: true,
          passive: true
        }
      );
    });

    align();

    requestAnimationFrame(align);

    // Support late Shopify layout changes briefly.

    timer = window.setInterval(function () {
      if (Date.now() - started > MAX_WATCH_MS) {
        finish();
        return;
      }

      align();
    }, 140);

    window.addEventListener(
      'load',
      align,
      { once: true }
    );

    window.addEventListener(
      'pageshow',
      align
    );

    document.addEventListener(
      'shopify:section:load',
      align
    );

    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(function () {
        if (!finished && !visitorMoved) {
          requestAnimationFrame(align);
        }
      });

      observer.observe(wrapper);
      observer.observe(header);
      observer.observe(sky);
    }

    stopAt = window.setTimeout(
      finish,
      MAX_WATCH_MS + 200
    );
  }

  window.ppMuseSecretSky = {
    phase: phase,

    getGeometry: geometry,

    getInitialMenuScroll: function () {
      return initialTarget;
    },

    stop: visitorInteracted
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      begin,
      { once: true }
    );
  } else {
    begin();
  }
})();
